import React, { useState, useEffect } from 'react';
import { 
  Container,
  TextField,
  Box,
  Typography,
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Button,
  Divider
} from '@mui/material';
import Layout from '../components/Layout';

const People = () => {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    fetchUsers();
  }, []);

  useEffect(() => {
    const filtered = users.filter(user =>
      user.displayName.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredUsers(filtered);
  }, [searchTerm, users]);

  const fetchUsers = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch('https://kast-server-713b1c89d478.herokuapp.com/api/auth/users', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const data = await response.json();
      console.log("User data is: ", data);
      
      setUsers(data);
      setFilteredUsers(data);
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };

  const getAvatarContent = (user) => {
    if (user.avatarUrl) {
      return <Avatar src={user.avatarUrl} />;
    }
    return <Avatar>{user.displayName.charAt(0)}</Avatar>;
  };

  return (
    <Layout>
      <Container maxWidth="md" sx={{ py: 3 }}>
        {/* Search Section */}
        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
            Search for Kast users
          </Typography>
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Search users..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
             sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "12px", // Change this to your desired radius
            },
            backgroundColor:'white',            
          }}
          />
        </Box>

        {/* Users List */}
        <List sx={{ width: '100%', bgcolor: '#fefaf5', border:'solid 1px black', borderRadius:'12px', padding:'10px' }}>
          {filteredUsers.map((user) => (
            <React.Fragment key={user.id}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2, mt:2 }}>
                                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    
                                                           <Avatar 
                                                                          src={user.profilePicture || `https://ui-avatars.com/api/?name=${user.displayName}&background=FF890A&color=fff`}
                                                                          sx={{ width: 32, height: 32, mr:1.5 }}
                                                                        >
                                                                          {! !user.profilePicture && user.displayName?.charAt(0)}
                                                                        </Avatar>
                                    <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                                      {user.displayName}
                                    </Typography>
                                  </Box>                                  
                                </Box>
             
            </React.Fragment>
          ))}
        </List>

        {/* Invite Section */}
        <Box sx={{ mt: 4, textAlign: 'center' }}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Invite a friend who'd enjoy Kast!
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            kast.it.com
          </Typography>
          <Button 
            variant="contained"
            sx={{
              backgroundColor: '#FF890A',
              '&:hover': { backgroundColor: '#e67a09' },
              fontWeight: 600
            }}
          >
            Invite Friends
          </Button>
        </Box>
      </Container>
    </Layout>
  );
};

export default People;